import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { LfsaBotonsGridComponent } from 'src/app/shared/components/lfsa-botons-grid/lfsa-botons-grid.component';
import { PromocionesService } from '../../services/promociones.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { Material } from '../../../portfolio/interfaces/material.interface';
import { arrayToCsv } from 'src/utils/utils';
import { ModalVariantesComponent } from '../../components/modal-variantes/modal-variantes.component';

@Component({
  selector: 'app-promocion-bonificadores',
  templateUrl: './promocion-bonificadores.component.html',
  styleUrls: ['./promocion-bonificadores.component.css']
})
export class PromocionBonificadoresComponent implements OnInit {

  @ViewChild(ModalVariantesComponent)
  modalVariantesComp?: ModalVariantesComponent;

  gridApi: any;
  gridColumnApi: any;
  columnDefsBonificadores = [];
  frameworkComponents: any;
  rowDataBonificadores: any[] = [];
  verFormularioAgregarBonificador = false;

  bonificador?: any;
  idPromo: string;
  grupos: boolean;
  tipoPromo: string;
  material: Material;

  // Variantes (Combos tipo 10)
  bonificadorParaVariante?: any;
  mostrarModalVariantes: boolean = false;

  get isCombo(): boolean {
    return `${this.tipoPromo}` === '10' || `${this.tipoPromo}`.toUpperCase().includes('COMBO');
  }

  constructor(
    private readonly route: ActivatedRoute,
    private readonly promocionesService: PromocionesService,
    private readonly _util: UtilsService
  ) {
    this.gridComponent();
  }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      const id = params['id'] as string;
      if (id) {
        this.idPromo = id;
        this.cargarBonificador(id);
        if (!this.tipoPromo) {
          this.promocionesService.buscarPromo(id).subscribe((promo) => {
            if (promo) {
              this.tipoPromo = `${promo.tipo_promo}`;
              this.grupos = Boolean(promo.suma_por_grupos);
              this.gridComponent();
              if (this.gridApi) {
                this.gridApi.setColumnDefs(this.columnDefsBonificadores);
                this.gridApi.sizeColumnsToFit();
              }
            }
          });
        }
      }
    });
    this.route.queryParams.subscribe((query) => {
      if (query['tipo_promo']) {
        this.tipoPromo = `${query['tipo_promo']}`;
      }
      this.grupos = query['grupos'] ? query['grupos'] === '1' : false;
      this.gridComponent();
      if (this.gridApi) {
        this.gridApi.setColumnDefs(this.columnDefsBonificadores);
        this.gridApi.sizeColumnsToFit();
      }
    });
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }

  gridComponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
      iconButtonRenderer: LfsaBotonsGridComponent
    };

    const columnasAcciones: any[] = [];

    if (this.isCombo) {
      columnasAcciones.push({
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 95,
        cellStyle: {
          padding: 0
        },
        cellRendererParams: {
          onClick: this.abrirModalVariantes.bind(this),
          label: 'Variantes',
          colorBoton: 'btn btn-success btn-block btn-sm text-white',
        },
      });
    }

    columnasAcciones.push(
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 60,
        cellStyle: {
          padding: 0
        },
        cellRendererParams: {
          onClick: this.editarBonificador.bind(this),
          label: 'Editar',
          colorBoton: 'btn btn-info btn-block btn-sm',
        },
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 60,
        cellStyle: {
          padding: 0
        },
        cellRendererParams: {
          onClick: this.eliminarBonificador.bind(this),
          label: 'Eliminar',
          colorBoton: 'btn btn-danger btn-block btn-sm',
        },
      }
    );

    this.columnDefsBonificadores = [
      {
        headerName: 'Material',
        field: 'id_material',
        sortable: true,
        filter: true,
        width: 130,
      },
      {
        headerName: 'Descripción Material',
        field: 'name_material',
        sortable: true,
        filter: true,
        minWidth: 260,
        flex: 1,
      },
      {
        headerName: 'Un',
        field: 'id_unidad',
        sortable: true,
        filter: false,
        width: 65,
      },
      {
        headerName: 'Ctd1',
        field: 'cantidad1',
        sortable: true,
        filter: false,
        width: 75,
      },
      {
        headerName: 'Ctd2',
        field: 'cantidad2',
        sortable: true,
        filter: false,
        width: 75,
      },
      {
        headerName: 'Ctd3',
        field: 'cantidad3',
        sortable: true,
        filter: false,
        width: 75,
      },
      {
        headerName: 'Grupo',
        field: 'id_grupo',
        sortable: true,
        filter: false,
        width: 90,
      },
      {
        headerName: 'Rel2.1',
        field: 'relacion21',
        sortable: true,
        filter: false,
        width: 75,
      },
      {
        headerName: 'Desc.',
        field: 'descuento',
        sortable: true,
        filter: false,
        width: 75,
      },
      ...columnasAcciones
    ];
  }

  cargarBonificador(id_promo) {
    this.promocionesService.cargarBonificador(id_promo.trim()).subscribe(
      (resp) => {
        if (resp) {
          this.rowDataBonificadores = resp;
        } else {
          this.rowDataBonificadores = [];
        }
      },
      (error) => {
        this.rowDataBonificadores = [];
      }
    );
  }

  nuevoBonificador() {
    this.bonificador = undefined;
    this.verFormularioAgregarBonificador = true;
  }

  editarBonificador({ rowData }) {
    this.bonificador = rowData;
    this.verFormularioAgregarBonificador = true;
  }

  back() {
    this.verFormularioAgregarBonificador = false;
    this.material = undefined;
  }

  guardarBonificador(payload: any) {
    payload.cantidad1 = payload.cantidad1 ? parseFloat(payload.cantidad1) : 0;
    payload.cantidad2 = payload.cantidad2 ? parseFloat(payload.cantidad2) : 0;
    payload.cantidad3 = payload.cantidad3 ? parseFloat(payload.cantidad3) : 0;
    payload.descuento = payload.descuento ? parseFloat(payload.descuento) : 0;
    payload.relacion21 = payload.relacion21 ? parseInt(payload.relacion21) : 0;

    this._util
      .confirmarSincronoPromesa({
        title: '¿Esta seguro que desea procesar el siguiente formulario?',
        // text: `ID PROMO: ${this.agregarForm.get('id_promo').value}`,
        action: this.bonificador ? 'Editar' : 'Nuevo',
        funcion: this.promocionesService.crearBonificador(payload),
      })
      .then((res: any) => {
        this.cargarBonificador(this.idPromo);
        this.verFormularioAgregarBonificador = false;
      });
  }

  eliminarBonificador({ rowData }) {
    this._util
      .confirmarSincronoPromesa({
        title: 'Eliminar',
        // text: `ID PROMO: ${rowData.id_promo}`,
        action: 'Eliminar',
        funcion: this.promocionesService.borrarBonificador(rowData),
      })
      .then((res: any) => {
        this.cargarBonificador(this.idPromo);
      });
  }

  eliminarTodo() {
    this._util
      .confirmarSincronoPromesa({
        title: 'Eliminar',
        // text: `ID PROMO: ${rowData.id_promo}`,
        action: 'Eliminar',
        funcion: this.promocionesService.bonificadorDeleteAll(this.idPromo),
      })
      .then((res: any) => {
        this.cargarBonificador(this.idPromo);
      });
  }

  abrirModalVariantes({ rowData }) {
    this.bonificadorParaVariante = rowData;
    this.mostrarModalVariantes = true;
  }

  cerrarModalVariantes() {
    this.mostrarModalVariantes = false;
    this.bonificadorParaVariante = undefined;
  }

  materialSelected(material: Material) {
    if (this.mostrarModalVariantes && this.modalVariantesComp) {
      this.modalVariantesComp.setMaterialVariante(material);
    } else {
      this.material = material;
    }
  }

  downloadCsv() {
    let csv = arrayToCsv([
      ['idPromo','nombre promocion', 'idMaterial', 'descripcion material', 'unidad', 'cantidad1', 'cantidad2', 'cantidad3', 'grupo', 'relacion21', 'descuento'],
      ...this.rowsAsArray()
    ]);
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    var url = URL.createObjectURL(blob);

    var pom = document.createElement('a');
    pom.href = url;
    pom.setAttribute('download', `bonos_${this.idPromo}.csv`);
    pom.click();
  }

  private rowsAsArray(): string[][] {
    const result:string[][] = [];
    this.rowDataBonificadores.forEach((row) => {
      const csv = {
        id: row.id_promo,
        promo: row.name_promo,
        idMaterial: row.id_material,
        dscMaterial: row.name_material,
        unidad: row.id_unidad,
        cantidad1: row.cantidad1 ? row.cantidad1 : '',
        cantidad2: row.cantidad2 ? row.cantidad2 : '',
        cantidad3: row.cantidad3 ? row.cantidad3 : '',
        grupo: row.id_grupo ? row.id_grupo : '',
        relacion21: row.relacion21 ? row.relacion21 : '',
        descuento: row.descuento ? row.descuento : '',
      }
      result.push(Object.values(csv));
    })
    return result;
  }

}
